export const envVars = {
    apiBasePath: process.env.REACT_APP_API_URL as string
};
